module.exports = __webpack_public_path__ + "static/img/23_liuliang2.f228daea.png";